import { cva } from "class-variance-authority";

/**
 * Page root: full-width on mobile; Figma tablet column 582px; desktop 630px.
 */
export const downloadAppRootStyles = cva([
  "w-full flex flex-col items-center",
  "px-4 pt-8 pb-8 md:px-8 md:pt-12 md:pb-12 lg:pt-16 lg:pb-16",
  "gap-8 md:mx-auto md:w-full md:max-w-[582px] lg:max-w-[630px]",
]);

/**
 * Headline: Figma mobile display small 36/44; tablet+ display medium 45/52.
 */
export const downloadAppHeadlineStyles = cva([
  "m-0 w-full text-left text-[#1B1C1D] font-medium tracking-tight",
  "text-[36px] leading-[44px] md:text-[45px] md:leading-[52px]",
]);

/**
 * White card: QR + CTA (tablet/desktop). Figma: 16px radius, 32px padding, single soft shadow.
 */
export const downloadAppCardStyles = cva([
  "w-full min-w-0 box-border rounded-2xl bg-white p-8",
  "shadow-[0px_1px_1.5px_rgba(0,0,0,0.1)]",
  "flex flex-col gap-8",
]);

/**
 * QR image: Figma ~324×317 on tablet/desktop. No frame/border around the asset.
 */
export const downloadAppQrImageStyles = cva([
  "w-full max-w-[324px] h-auto object-contain object-center border-0",
  "aspect-[324/317]",
]);

/**
 * Caption under QR — Freedom M3 / label / medium (Figma node 4001:58511):
 * 12px / 16px line-height / weight 500 / on-surface / 0.5px tracking, single line.
 */
export const downloadAppQrLabelStyles = cva([
  "m-0 text-center not-italic whitespace-nowrap tracking-[0.5px]",
  "text-label-md text-on-surface",
]);

export const downloadAppCtaRowStyles = cva([
  "w-full flex flex-col items-center",
]);

/**
 * "Continue on web" text button — Figma Code Connect node 4001:58520: Text, Round, XSmall.
 * M3 label/medium (tokens); color from Button `variant="text"` (`text-primary`).
 * `!` on type metrics so they win over `Button` `size="small"` (clsx-only merge, no tailwind-merge).
 */
export const downloadAppCtaButtonStyles = cva([
  "!min-w-0 !font-medium tracking-[0.5px] not-italic",
  "!text-[length:var(--md-sys-typescale-label-medium-size)] !leading-[length:var(--md-sys-typescale-label-medium-line-height)]",
  "px-3 py-2",
]);

/** QR + caption: Figma 16px padding around QR block; 4px between image and label. */
export const downloadAppQrSectionStyles = cva([
  "flex flex-col items-center w-full gap-1 p-4",
]);

/** Mobile-only: stack store badges (Figma 16px between, 24px before CTA). */
export const downloadAppMobileStoreSectionStyles = cva([
  "flex flex-col items-center w-full gap-4",
]);

export const downloadAppStoreBadgeLinkStyles = cva([
  "block rounded-md overflow-hidden shrink-0",
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
  "w-[204px] h-[68px]",
]);

export const downloadAppStoreBadgeImageStyles = cva([
  "block h-[68px] w-[204px] object-contain",
]);
